import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import convertHTMLtoJSX from "@/next-src/utils/convertHTMLtoJSX";
import useWindowDimensions from "@/next-src/hooks/useWindowDimensions";

import comCSS from "./Benefit.module.scss";
import ResponsiveImage from "@/next-src/components/ui/responsive-image/ResponsiveImage";

const Benefit = ({ className = "", data }) => {
  const { width: windowWidth } = useWindowDimensions();
  const { titleMobile, textMobile, image } = data || {};

  let { title, text } = data || {};

  if (windowWidth < 992) {
    title = titleMobile;
    text = textMobile;
  }

  return (
    <div className={cn(className, comCSS.wrapper, "grid-item max-width-80")}>
      <div className="margin-bottom margin-xxsmall">
        <ResponsiveImage
          width={38}
          height={38}
          src={image?.src}
          lazyLoading
          alt={image?.alt}
          className="icon-1x1-semi-medium"
          sizes="38px"
        />
      </div>
      <div className="margin-bottom margin-xxsmall">
        {convertHTMLtoJSX(title)}
      </div>
      <div className="text-color-slate-grey text-size-small">
        {convertHTMLtoJSX(text)}
      </div>
    </div>
  );
};

Benefit.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    titleMobile: PropTypes.string,
    text: PropTypes.string,
    textMobile: PropTypes.string,
    image: PropTypes.shape({
      id: PropTypes.string,
      src: PropTypes.string,
      alt: PropTypes.string,
    }),
    hide: PropTypes.bool,
  }),
};

export default Benefit;
